<script setup>
import { computed, getCurrentInstance } from 'vue';
import Button from "../../common/Button.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const sectionName = computed(() => store.state.themes.sectionName);
const sectionsData = computed(() => store.state.themes.sectionsData);

const selectedSectionTitle = computed(() => {
    // Using .find() is slightly cleaner than .filter()[0]
    const activeSection = sectionsData.value.find(obj => obj.tableName === sectionName.value);
    return activeSection ? activeSection.title : 'Sections';
});

// --- Methods ---

const setSectionName = (tableName) => {
    store.dispatch('themes/setSectionName', tableName);
};
</script>

<template>
    <div class="dropdown">
        <Button class="btn-sm dropdown-toggle" data-bs-toggle="dropdown">
            {{ selectedSectionTitle }}
        </Button>

        <div class="dropdown-menu">
            <button
                v-for="section in sectionsData"
                :key="section.tableName"
                :class="{'active': section.tableName === sectionName}"
                class="dropdown-item"
                type="button"
                @click="setSectionName(section.tableName)"
            >
                {{ section.title }}
            </button>
        </div>
    </div>
</template>